import React, { Component } from 'react'
import { checkTranslation } from '../../../utils/useful'

export default class Notification extends Component {
    state = {
        notifications: [
            { img: '/images/p4.png', name: 'Ralph Edwards', action: '{{lang}}notification.Wants to edit', target: '{{lang}}notification.Elitive System Design', time: '5 min ago', accept: '{{lang}}notification.Accept', deny: '{{lang}}notification.Deny' },
            { img: '/images/p1.png', name: 'Ralph Edwards', action: '{{lang}}notification.Wants to edit', target: '{{lang}}notification.Elitive System Design', time: '5 min ago', accept: '{{lang}}notification.Accept', deny: '{{lang}}notification.Deny' },
            { img: '/images/p2.png', name: 'Ralph Edwards', action: '{{lang}}notification.Wants to edit', target: '{{lang}}notification.Elitive System Design', time: '5 min ago', accept: '{{lang}}notification.Accept', deny: '{{lang}}notification.Deny' },
            { img: '/images/p3.png', name: 'Ralph Edwards', action: '{{lang}}notification.Wants to edit', target: '{{lang}}notification.Elitive System Design', time: '5 min ago', accept: '{{lang}}notification.Accept', deny: '{{lang}}notification.Deny' },
            { img: '/images/p4.png', name: 'Ralph Edwards', action: '{{lang}}notification.Wants to edit', target: '{{lang}}notification.Elitive System Design', time: '5 min ago', accept: '{{lang}}notification.Accept', deny: '{{lang}}notification.Deny' },
            { img: '/images/p5.png', name: 'Ralph Edwards', action: '{{lang}}notification.Wants to edit', target: '{{lang}}notification.Elitive System Design', time: '5 min ago', accept: '{{lang}}notification.Accept', deny: '{{lang}}notification.Deny' },
            { img: '/images/p6.png', name: 'Ralph Edwards', action: '{{lang}}notification.Wants to edit', target: '{{lang}}notification.Elitive System Design', time: '5 min ago', accept: '{{lang}}notification.Accept', deny: '{{lang}}notification.Deny' },
            { img: '/images/p7.png', name: 'Ralph Edwards', action: '{{lang}}notification.Wants to edit', target: '{{lang}}notification.Elitive System Design', time: '5 min ago', accept: '{{lang}}notification.Accept', deny: '{{lang}}notification.Deny' },
            { img: '/images/p8.png', name: 'Ralph Edwards', action: '{{lang}}notification.Wants to edit', target: '{{lang}}notification.Elitive System Design', time: '5 min ago', accept: '{{lang}}notification.Accept', deny: '{{lang}}notification.Deny' },
        ]
    }
    setData = (key, value, reference, cb) => {
        if (reference == 'Notification') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }

    render() {
        return (
            <div>
                {this.state.notifications.map((prop, index) => {
                    return (
                        <div className='bb-gray'>
                            <div className='d-flex py-3'>
                                <img width={35} height={35} className='br-50 mt-1' src={prop.img} />
                                <div className='mld-3'>
                                    <div className=''>
                                        <p className='font-size-12 weight-500 main-c4'>{checkTranslation(prop.name)} <span className='font-size-12 weight-300 main-c4'>{checkTranslation(prop.action)}</span> <span className='font-size-12 weight-500 main-c4'>{checkTranslation(prop.target)}</span></p>
                                        <p className='font-size-12 main-c7'>{checkTranslation(prop.time)}</p>
                                    </div>
                                    <div className='flexc mt-2'>
                                        <button className='purple-btn px-3 py-1 br-5'>
                                            <p>{checkTranslation(prop.accept)}</p>
                                        </button>
                                        <button className='gray-btn px-3 py-1 br-5 mld-3'>
                                            <p>{checkTranslation(prop.deny)}</p>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}
